import { basePathHelper } from '../../../setup/base-path.helper';

export const SiteHeader = (): React.ReactElement<any, any> => {
    return (
        <>
            <div className='text-center py-3 bg-nav-primary'>
                <img height='57px' src={`${basePathHelper.appPath}/theme/logo.png`} alt='' />
            </div>
            <div className='bg-nav-secondary py-2'>
                <div className='layout-max-width mx-auto px-3 text-nav'>&nbsp;</div>
            </div>
        </>
    );
};
